<template>
  <v-container class="px-0 pt-3 pb-5">
    <v-card class="pb-3" outlined width="100%">
        <v-card-text>
            <v-row>
                <v-col class="pt-0 pb-5" cols="12">
                    <h2 class="authorizer-title">
                        <b>Feriados cadastrados</b>
                    </h2>
                </v-col>
                <v-col v-show="!showBtn" class="text-center" cols="12">
                    <p style="font-size:20px">Selecione um prestador</p>
                </v-col>
                <v-col v-show="showBtn" class="px-2 py-0" cols="12" sm="12" md="6">
                    <v-select
                        v-model="formData.year"
                        :items="years"
                        :menu-props="{ bottom: true, offsetY: true }"
                        flat
                        solo
                        dense
                        outlined
                        @change="selectYear(formData.year)"
                    ></v-select>
                </v-col>
                <v-col v-show="showBtn" class="text-right px-2 pt-0 pb-3" cols="12" sm="12" md="6">
                    <v-btn
                        outlined
                        width="100%"
                        height="32px"
                        small
                        color="primary"
                        depressed
                        class="px-2"
                        @click="addFeriados(formData)"
                    >adicionar feriados nacionais</v-btn>
                </v-col>
                <v-col v-show="showBtn" class="px-0 py-0" cols="12" sm="12" md="12">
                    <v-row class="ma-0" v-for="item in list" :key="item.id">
                        <v-col class="text-left px-3 py-2" cols="3">
                            {{item.dt_feriado | formatDate}}
                        </v-col>
                        <v-col class="text-right pa-2" cols="8">
                            {{item.descricao}}
                        </v-col>
                        <v-col class="pa-0" cols="1">
                            <v-btn icon @click="deletar(item)">
                                <v-icon size="14px" color="primary">fa-trash-alt</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col class="pa-0" cols="12">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card> 
  </v-container>
</template>

<script>
import moment from "moment";
moment.locale("pt-BR");
export default {
    data() {
        return {
            formData: {
                year:null
            },
            years:[]
        }
    },
    filters: {
        formatDate(date) {
            return moment(date).format("L");
        },
    },
    mounted() {
        let y = []
        let d = new Date().getFullYear()
        for (let i = d; i <= d + 100; i++) {
            y.push(i);
        }
        this.years = y
    },
    watch: {
        YearCurrent(year) {
            this.formData.year = year
        }
    },
    methods: {
        deletar(item) {
            let paramModal = {
                type: "error",
                title: "Excluir feriado?",
                message: item.descricao,
                callback: () => {
                    let obj = {
                        id:item.id, 
                        year: this.formData.year
                    }
                    this.delItem(obj)
                },
                btConfirm: { name: "Ok", show: true, color: '#D0021B' },
                btCancel: { name: 'Cancelar', show: true }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        }
    },
    props: {
        list: Array,
        delItem: Function,
        selectYear: Function,
        YearCurrent: Number,
        addFeriados: Function,
        showBtn: Boolean,
    }
}
</script>

<style>

</style>